import { render, staticRenderFns } from "./Comuni.vue?vue&type=template&id=5bed681c&scoped=true&"
import script from "./Comuni.vue?vue&type=script&lang=js&"
export * from "./Comuni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed681c",
  null
  
)

export default component.exports